import * as React from 'react';
import { FunctionComponent } from 'react';
import { getFullName } from 'Src/helpers/autocomplete/autocomplete';
import './SchoolEventJobsSummary.scss';

interface Props {
  eventTasks: any[];
  onEditEventJobClick: (e, index) => void;
  onDeleteJobClick: (e, index) => void;
}

export const SchoolEventJobsSummary: FunctionComponent<Props> = ({
  eventTasks,
  onEditEventJobClick,
  onDeleteJobClick
}) => (
  <section className="eventJobs">
    <header className="eventJobs__header">
      <div>
        <h2 className="eventJobs__title">Jobs</h2>
        <p className="eventJobs__subtitle">Assign event-day tasks to players and participants.</p>
      </div>
      <span className="eventJobs__count">
        {eventTasks.length} {eventTasks.length === 1 ? 'job' : 'jobs'}
      </span>
    </header>

    {eventTasks.length > 0 ? (
      <div className="eventJobs__list">
        {eventTasks.map((eventTask, index) => (
          <article className="eventJobCard" key={eventTask.id || `event-job-${index}`}>
            <div className="eventJobCard__number">{index + 1}</div>
            <div className="eventJobCard__content">
              <h3 className="eventJobCard__description">{eventTask.text}</h3>
              <div className="eventJobCard__assignees" aria-label="Assigned participants">
                {(eventTask.assignees || []).map(assignee => (
                  <span className="eventJobCard__chip" key={assignee.permissionId || assignee.userId}>
                    {getFullName(assignee)}
                  </span>
                ))}
              </div>
            </div>
            <div className="eventJobCard__actions">
              <button type="button" className="eventJobCard__action" onClick={e => onEditEventJobClick(e, index)}>
                Edit
              </button>
              <button
                type="button"
                className="eventJobCard__action eventJobCard__action--danger"
                onClick={e => onDeleteJobClick(e, index)}
              >
                Delete
              </button>
            </div>
          </article>
        ))}
      </div>
    ) : (
      <div className="eventJobs__empty">
        <div className="eventJobs__emptyIcon">Jobs</div>
        <h3>No jobs yet</h3>
        <p>Create a job to make responsibilities clear before the event starts.</p>
      </div>
    )}
  </section>
);

SchoolEventJobsSummary.displayName = 'SchoolEventJobsSummary';
